import { CheckIcon } from '@heroicons/react/solid';
import classNames from 'classnames';
import { memo, useMemo } from 'react';

import { Button } from '@/lib/v2/components/Button';
import { Text } from '@/lib/v2/components/Text';

import { StepperItemProps } from './StepperItem';

export const StepperUpcomingIcon = () => (
  <span className="relative flex size-6 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400">
    <span className="size-2.5 rounded-full bg-transparent group-hover:bg-gray-300" />
  </span>
);

export const StepperCurrentIcon = () => (
  <span className="relative flex size-6 items-center justify-center rounded-full border-2 border-emblueGreen bg-white">
    <span className="size-2.5 rounded-full bg-emblueGreen" />
  </span>
);

export const StepperDoneIcon = () => (
  <span className="relative flex size-6 items-center justify-center rounded-full bg-emblueGreen group-hover:bg-emblueGreen">
    <CheckIcon aria-hidden="true" className="size-5 text-white" />
  </span>
);

export type StatusStepperItem = 'upcoming' | 'current' | 'done';

export type StepperItemHorizontalProps = StepperItemProps;

const StepperItemHorizontal = ({
  status,
  stepName,
  title,
  subTitle,
  description,
  id,
  buttonText,
  onClickButton,
  onClick,
  children,
}: StepperItemHorizontalProps) => {
  const icon = useMemo(() => {
    if (status === 'upcoming') return <StepperUpcomingIcon />;
    else if (status === 'current') return <StepperCurrentIcon />;
    else return <StepperDoneIcon />;
  }, [status]);

  const classesLine = classNames('horizontal-line', {
    'bg-gray-300': status !== 'done',
    'bg-emblueGreen': status === 'done',
  });

  const classesSteep = classNames('flex flex-col gap-4');

  return (
    <div className={'stepper-item w-full hover:cursor-pointer'} id={id?.toString()}>
      <div className={classesSteep} onClick={onClick}>
        <div className="relative pt-1">
          <div className={classesLine}></div>
          {icon}
        </div>
        <div className="flex flex-col text-left">
          <div className="flex flex-col">
            <Text color="light-black" variant="text-sm">
              {stepName.toUpperCase()}
            </Text>
            <Text color="primary" fontWeight="normal" variant="sub-headline">
              {title}
            </Text>
            <Text color="light-black" variant="text-sm">
              {subTitle}
            </Text>
          </div>
          {status === 'current' && (
            <div className="mt-4 flex flex-col gap-4">
              <Text variant="text">{description}</Text>
              {buttonText && (
                <Button size="small" onClick={onClickButton}>
                  {buttonText}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(StepperItemHorizontal);
